/**
 * Maps API response items to FieldOption objects. Pure function.
 * Numeric-zero values are preserved (`String(0) === '0'`, then the empty-value
 * filter passes); only null/undefined/empty-string values are dropped.
 *
 * Used by `createApiOptionsLoader` and `createApiOptionsLookup` so both produce
 * identical option shapes from identical backend payloads.
 *
 * @param {unknown[]} items
 * @param {{
 *   valueProp?: string,
 *   labelProp?: string,
 *   iconProp?: string,
 *   iconAs?: string,
 * }} [config]
 * @returns {import('../../contracts/forms.js').FieldOption[]}
 */
export function mapApiItemsToOptions(items, config) {
  const {
    valueProp = 'value',
    labelProp = 'label',
    iconProp,
    iconAs,
  } = config ?? {};

  return items
    .filter(item => item != null && typeof item === 'object')
    .map(item => {
      const obj = /** @type {Record<string, unknown>} */ (item);
      /** @type {import('../../contracts/forms.js').FieldOption} */
      const opt = {
        value: obj[valueProp] != null ? String(obj[valueProp]) : '',
        label: obj[labelProp] != null ? String(obj[labelProp]) : '',
      };
      if (iconProp && obj[iconProp] != null) {
        const val = String(obj[iconProp]).trim();
        if (val) {
          if (iconAs === 'image') {
            opt.iconUrl = val;
          } else {
            opt.icon = val;
          }
        }
      }
      return opt;
    })
    .filter(opt => opt.value !== '');
}
